export default "__VITE_ASSET__neQQzP1X__"